import React from 'react';
import { withRouter } from 'react-router';
import _ from 'lodash';
import moment from 'moment-timezone';
import Dropdown from '../../dashboard/common/dropdown/Dropdown';
import CheckedIn from '../../../assets/svg/emergencyPersonnel/checked.svg';

class LeftArea extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allCheckedIn: [],
      allNotCheckedIn: [],
      filteredCheckedIn: [],
      filteredNotCheckedIn: [],
      skills: [],
    };

    this.changeSelectedFilter = this.changeSelectedFilter.bind(this);
    this.previewFloorPlan = this.previewFloorPlan.bind(this);
  }

  componentDidMount() {
    const { fetchEmergencyPersonnel, assignedOfficeId, emergencyBuildingId } = this.props;
    fetchEmergencyPersonnel(emergencyBuildingId || assignedOfficeId);
  }

  componentDidUpdate(prevProps, prevState) {
    const { emergencyPersonnel: oldEmergencyPersonnel, emergencyBuildingId: oldEmergencyBuildingId } = prevProps;
    const { emergencyPersonnel, translations } = this.props;
    if (oldEmergencyPersonnel !== emergencyPersonnel && emergencyPersonnel.skills) {
      const { skills } = emergencyPersonnel;
      skills.unshift(_.get(translations, 'all', 'ALL'));
      this.setState({ allCheckedIn: emergencyPersonnel.checkedIn });
      this.setState({ filteredCheckedIn: emergencyPersonnel.checkedIn });
      this.setState({ allNotCheckedIn: emergencyPersonnel.notCheckedIn });
      this.setState({ filteredNotCheckedIn: emergencyPersonnel.notCheckedIn });
      this.setState({ skills });
    }
  }

  previewFloorPlan(hero) {
    const {
      history,
      setSelectedPin,
      setSelectedDate,
      setSelectedProductType,
      emergencyBuildingId,
      assignedOfficeId,
      emergencyPersonnel,
    } = this.props;
    const { officeTimezone } = emergencyPersonnel;
    const { heroName, productId, floorId, productType, skills } = hero;
    const emergencyHero = { heroName, skills: skills.join('; '), productId };

    setSelectedDate(moment.tz(officeTimezone).format('MMM D, YYYY'));
    setSelectedPin(productId);
    setSelectedProductType(productType);

    history.push({
      pathname: `/location/${emergencyBuildingId || assignedOfficeId}`,
      state: { emergencyHero, fromEmergency: true, floorId },
    });
  }

  renderHeader() {
    const { emergencyPersonnel, translations, formatString } = this.props;

    const buttonTextLeft = emergencyPersonnel.buttonText
      ? emergencyPersonnel.buttonText
      : _.get(translations, 'emergencyPersonnel', 'Skilled Personnel');
    const title = emergencyPersonnel.officeName
      ? formatString(_.get(translations, 'at', '{0} at {1}'), buttonTextLeft, emergencyPersonnel.officeName)
      : buttonTextLeft;
    return (
      <div className="left-container__header">
        <div className="left-container__header--icon" />
        <div className="left-container__header--title">{title}</div>
      </div>
    );
  }

  renderCheckedInHeroes(filteredCheckedIn) {
    const { assignedOfficeId, emergencyBuildingId, translations } = this.props;
    const { allCheckedIn, allNotCheckedIn, skills } = this.state;
    let noHeroesMessage = '';

    if (allCheckedIn.length > 0 && filteredCheckedIn.length === 0) {
      noHeroesMessage = _.get(translations, 'noHeroWithSelectedSkill', 'There are no checked in heroes having selected skill.');
    }

    if (allCheckedIn.length === 0 && allNotCheckedIn.length === 0) {
      noHeroesMessage = _.get(
        translations,
        'noBookingsForSkilledPersonnel',
        'There are no bookings for current day made by skilled personnel.'
      );
    }

    if (allCheckedIn.length === 0 && allNotCheckedIn.length > 0) {
      noHeroesMessage = _.get(
        translations,
        'noCheckedInBookings',
        'There are no checked in bookings made by skilled personnel for current day.'
      );
    }

    if (!assignedOfficeId && skills.length <= 1 && !emergencyBuildingId) {
      noHeroesMessage = _.get(
        translations,
        'notAssignedToBuilding',
        'You are not assigned to any building. Please contact your administrator.'
      );
    }
    return (
      <>
        <div className="ep-box">
          {filteredCheckedIn.length > 0 &&
            filteredCheckedIn.map((hero, index) => {
              const tileInfo = hero.department
                ? `${hero.department}; ${hero.floor}; ${hero.productName} `
                : `${hero.floor}; ${hero.productName} `;
              return (
                <div key={index} className="ep-box-item__checked" onClick={() => this.previewFloorPlan(hero)}>
                  <div className="ep-box-item__status-checked">
                    <img className="ep-box-item__status-checked-image" src={CheckedIn} alt="checked-in" />
                    {_.get(translations, 'checkedIn', 'Checked In')}
                  </div>
                  <div className="ep-box-item__title">
                    <div className="ep-box-item__title-name">{hero.heroName}</div>
                    <div className="ep-box-item__title-skills">{hero.skills.join('; ')}</div>
                  </div>
                  <div className="ep-box-item__location">{tileInfo}&gt;</div>
                </div>
              );
            })}
          {filteredCheckedIn.length === 0 && <div className="ep-box__no-heroes">{noHeroesMessage}</div>}
        </div>
      </>
    );
  }

  renderUnCheckedHeroes(heroes) {
    const { translations, emergencyPersonnel } = this.props;
    const buttonText = emergencyPersonnel.buttonText
      ? emergencyPersonnel.buttonText
      : _.get(translations, 'emergencyPersonnel', 'Skilled Personnel');
    const otherTitle = `${_.get(translations, 'other', 'Other')} ${buttonText}`;
    return (
      heroes.length > 0 && (
        <>
          <div className="ep__border" />
          <div className="left-container__other-title">{otherTitle}</div>
          <div className="ep-box">
            {heroes.map((hero, index) => {
              return (
                <div key={index} className="ep-box-item">
                  <div className="ep-box-item__status-unchecked">{_.get(translations, 'notCheckedIn', 'Not Checked In')}</div>
                  <div className="ep-box-item__title">
                    <div className="ep-box-item__title-name">{hero.heroName}</div>
                    <div className="ep-box-item__title-skills">{hero.skills.join('; ')}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )
    );
  }

  changeSelectedFilter(filterId) {
    const { allCheckedIn, allNotCheckedIn, skills } = this.state;

    if (!filterId) {
      this.setState({ filteredCheckedIn: allCheckedIn });
      this.setState({ filteredNotCheckedIn: allNotCheckedIn });
      return;
    }

    this.setState({ filteredCheckedIn: allCheckedIn.filter(hero => hero.skills.indexOf(skills[filterId]) > -1) });
    this.setState({ filteredNotCheckedIn: allNotCheckedIn.filter(hero => hero.skills.indexOf(skills[filterId]) > -1) });
  }

  renderFilter(skills) {
    // eslint-disable-next-line react/prop-types
    const { translations } = this.props;

    const arrayFilter = skills.map((value, index) => {
      return { value, id: index };
    });

    return (
      skills.length > 1 && (
        <div className="media-filters-selector__container">
          <div className="media-filters-selector__picker-container">
            <Dropdown
              onChange={this.changeSelectedFilter}
              options={arrayFilter}
              selectedId={0}
              placeHolder={_.get(translations, 'all', 'ALL')}
              className="dropdown__selector filter__dropdown"
              customText={_.get(translations, 'filter', 'Filter: ')}
            />
          </div>
        </div>
      )
    );
  }

  render() {
    const { isLoading } = this.props;
    const { skills, filteredCheckedIn, filteredNotCheckedIn, allCheckedIn } = this.state;

    if (isLoading) return <div className="Loader" />;
    return (
      <>
        {this.renderHeader()}
        {this.renderFilter(skills)}
        {this.renderCheckedInHeroes(filteredCheckedIn)}
        {this.renderUnCheckedHeroes(filteredNotCheckedIn)}
      </>
    );
  }
}

export default withRouter(LeftArea);
